export default __webpack_public_path__ + "static/CCDE_mobile_400x600-acaca0fd04be12691f52259aa11fdbd1.jpg";